// Libraries
import { ReactNode } from 'react';

// Styles
import styles from './SessionIdle.module.css';

/**
 * @function SessionIdle
 * Describe the component's function
 *
 * @example
 * return (
 *   <SessionIdle></SessionIdle>
 * )
 */
function SessionIdle({
    heading = null,
    children = <></>,
}: SessionIdleProps): JSX.Element {
    return (
        <div className={styles.container}>
            <header className={styles.header}>
                {heading && <h1 className={styles.heading}>{heading}</h1>}
            </header>
            {children}
        </div>
    );
}

/**
 * @interface SessionIdleProps
 * Describes the properties required for the SessionIdle component
 *
 * @property {string} heading
 * @property {ReactNode} children
 */
export interface SessionIdleProps {
    heading?: string | ReactNode;
    children?: ReactNode;
}

// Exports
export default SessionIdle;
